import { render, staticRenderFns } from "./CategoryFilterCollapse.vue?vue&type=template&id=4017cb52&scoped=true&"
import script from "./CategoryFilterCollapse.vue?vue&type=script&lang=js&"
export * from "./CategoryFilterCollapse.vue?vue&type=script&lang=js&"
import style0 from "./CategoryFilterCollapse.vue?vue&type=style&index=0&id=4017cb52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4017cb52",
  null
  
)

export default component.exports